import { courseTermsApi } from "api/courseTermsApi";
import { QUERIES_KEYS } from "queries";
import { useQuery } from "@tanstack/react-query";

export const useCourseTerms = (courseId?: string | number) => {
  const { isLoading, data } = useQuery({
    queryKey: QUERIES_KEYS.COURSE_TERMS(courseId!),
    queryFn: () => courseTermsApi.getByCourseId(Number(courseId)),
    enabled: !!courseId,
  });

  return { isLoading, terms: data?.data?.terms ?? [] };
};
